export var NacionalidadeEnum;
(function (NacionalidadeEnum) {
    NacionalidadeEnum["BRASILEIRO"] = "BRASILEIRO";
    NacionalidadeEnum["ESTRANGEIRO"] = "ESTRANGEIRO";
    NacionalidadeEnum["NATURALIZADO"] = "NATURALIZADO";
})(NacionalidadeEnum || (NacionalidadeEnum = {}));
(function (NacionalidadeEnum) {
    var mapDescricao = new Map([
        [NacionalidadeEnum.BRASILEIRO, 'Brasileiro(a)'],
        [NacionalidadeEnum.ESTRANGEIRO, 'Estrangeiro(a)'],
        [NacionalidadeEnum.NATURALIZADO, 'Naturalizado Brasileiro(a)'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    NacionalidadeEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    NacionalidadeEnum.getOptions = getOptions;
})(NacionalidadeEnum || (NacionalidadeEnum = {}));
